const Plugin = {
  scanTime: 25,
  videoWidth: 1920,
  videoHeight: 1080,
  videoFrameRate: 30,
};

export default { Plugin };
